import React from 'react';
import styles from './ConfirmDeleteModal.module.scss';
import { ReactComponent as CloseIcon } from '../../assets/icons/close-icon.svg';
import { ReactComponent as DeleteButtonIcon } from '../../assets/icons/delete-button-icon.svg';
import { ReactComponent as SaveButtonIcon } from '../../assets/icons/save-button-icon.svg';

interface ConfirmDeleteModalProps {
    onClose: () => void;
    onConfirm: () => void;
    imageUrl: string;
    imagesCount: number;
    title: string;
}

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
                                                                          onClose,
                                                                          onConfirm,
                                                                          imageUrl,
                                                                          imagesCount,
                                                                          title,
                                                                      }) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <div className={styles.title}>Удаление товара</div>
                    <div className={styles.closeBtn} onClick={onClose}>
                        <CloseIcon />
                    </div>
                </div>
                <div className={styles.description}>
                    Вы действительно хотите удалить этот товар? Он пропадет из магазина и из списка товаров.
                </div>
                <div className={styles.tableHeader}>
                    <div className={styles.cardLeft}>
                        <div className={styles.photoWrapper}>
                            {imageUrl && (
                                <img src={imageUrl} alt={title} className={styles.productImage} />
                            )}
                            {(
                                <div className={styles.imagesCount}>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="24" height="24" rx="8" fill="#00CCC6"/>
                                        <text
                                            x="12"
                                            y="16"
                                            textAnchor="middle"
                                            fill="white"
                                            fontSize="11"
                                            fontWeight="bold"
                                        >
                                            +{imagesCount}
                                        </text>
                                    </svg>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={styles.cardRight}>
                        <div className={styles.cardTitle}>{title}</div>
                    </div>
                </div>
                <div className={styles.actions}>
                    <button onClick={onConfirm}>
                        <DeleteButtonIcon />
                    </button>
                    <button onClick={onClose}>
                        <SaveButtonIcon />
                    </button>
                </div>
            </div>
        </div>
    );
};
